import React, {useState} from 'react';
import {connect} from 'react-redux';
import {setEventDate, setMonthShown, setShowFutureEvents} from "../redux/actions";
import {value} from "lodash/seq";
import {changePageButtonHref, correctDateFormat, sameMonthStrings} from "../calendarHelper.js";


const DateChanger = ({year, month, monthsSelector, ...props}) => {
  const [curYear, setCurYear] = useState(year)

  const updateDateToChangeTo = (e) => {
    const actionNextPrev = e.target.className
    if (actionNextPrev.includes('next')) {
      setCurYear(curYear + 1)
    } else {
      setCurYear(curYear - 1)
    }
  }

  const pickMonth = (e) => {
    const monthNumber = Number(e.target.value);
    const theFirst = correctDateFormat(curYear,monthNumber);
    if (!sameMonthStrings(theFirst, props.today)) {
      props.setEventDate(theFirst);
    } else {
      props.setEventDate(props.today);
    }
    props.setShowFutureEvents()
    changePageButtonHref({year:curYear,month:monthNumber})
    props.setMonthShown({year:curYear,month:monthNumber});
    monthsSelector()
  }

  return (
    <div className="dateChanger">
      <div className="yearHeader">
        <button className="prev" onClick={updateDateToChangeTo} name="prev">
          <i className="fa-solid fa-chevron-left prev"></i>
        </button>
        {curYear}
        <button className="next" onClick={updateDateToChangeTo} name="next">
          <i className="fa-solid fa-chevron-right next"></i>
        </button>
      </div>
      <table className="monthPicker">
        <tbody>
        <tr>
          <td>
            <button name="month" value="0" className={`pickMonth`} onClick={pickMonth}>Jan</button>
          </td>
          <td>
            <button name="month" value="1" className={`pickMonth`} onClick={pickMonth}>Feb</button>
          </td>
          <td>
            <button name="month" value="2" className={`pickMonth`} onClick={pickMonth}>Mar</button>
          </td>
        </tr>
        <tr>
          <td>
            <button name="month" value="3" className={`pickMonth`} onClick={pickMonth}>Apr</button>
          </td>
          <td>
            <button name="month" value="4" className={`pickMonth`} onClick={pickMonth}>May</button>
          </td>
          <td>
            <button name="month" value="5" className={`pickMonth}`} onClick={pickMonth}>June</button>
          </td>
        </tr>
        <tr>
          <td>
            <button name="month" value="6" className={`pickMonth`} onClick={pickMonth}>July</button>
          </td>
          <td>
            <button name="month" value="7" className={`pickMonth`} onClick={pickMonth}>Aug</button>
          </td>
          <td>
            <button name="month" value="8" className={`pickMonth`} onClick={pickMonth}>Sept</button>
          </td>
        </tr>
        <tr>
          <td>
            <button name="month" value="9" className={`pickMonth`} onClick={pickMonth}>Oct</button>
          </td>
          <td>
            <button name="month" value="10" className={`pickMonth`} onClick={pickMonth}>Nov</button>
          </td>
          <td>
            <button name="month" value="11" className={`pickMonth`} onClick={pickMonth}>Dec</button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  )
}

const mapStateToProps = state => ({
  month: state.calendarEvents.month,
  year: state.calendarEvents.year,
});

const mapDispatchToProps = {
  setMonthShown,
  setEventDate,
  setShowFutureEvents,
};


export default connect(mapStateToProps, mapDispatchToProps)(DateChanger);